// @flow
import classNames from 'classnames/bind';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import { FormattedMessage, intlShape } from 'react-intl';
import {Link} from 'react-router-dom';
import logoApple from '../../../../assets/img/custom-products/iphone/apple-logo.png';
import {CommaFormat} from '../../../../elements/Price/Price';
import environment from '../../../../environment';
import FeatureSelect from '../../components/FeatureSelect/FeatureSelect';

import coverCOImg from '../../../../assets/img/home_meta_CO_cover.png';
import coverPEImg from '../../../../assets/img/home_meta_PE_cover.png';
import coverUSImg from '../../../../assets/img/home_meta_US_cover.png';

import withCharger from '../../../../assets/img/custom-products/airpods/with-charger.jpeg';
import withWirelessCharger from '../../../../assets/img/custom-products/airpods/with-wireless-chager.jpeg';
import pro from '../../../../assets/img/custom-products/airpods/pro.jpeg';
import maxSpaceGray from '../../../../assets/img/custom-products/airpods/max-space-gray.png';
import maxSilver from '../../../../assets/img/custom-products/airpods/max-silver.png';
import maxGreen from '../../../../assets/img/custom-products/airpods/max-green.png';
import maxSkyBlue from '../../../../assets/img/custom-products/airpods/max-sky-blue.png';
import maxPink from '../../../../assets/img/custom-products/airpods/max-pink.png';

import featureStyle from '../../components/FeatureSelect/FeatureSelect.scss';
import ProductBase from '../../components/ProductBase/ProductBase';
import style from './Airpods.scss';

import type {LocalValuesState} from '../../../local-values/duck';
import type {LocaleState} from '../../../locale/duck';

type AirpodsProduct = {
  name: string;
  title: string;
  description: string;
  model: string;
  image?: string;
  images?: { [key: string]: string };
  colors?: string[];
  prices?: { [key: string]: string };
  price?: string;
  url: string;
};

type Props = {
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +location: Location;
};

type State = {
  color: string;
  image: string;
  airpods: string;
};

const airpodsPages = [
  { name: 'AirPods with Charging Case', model: 'Charging Case', url: '/custom-product/airpods-with-charging-case' },
  { name: 'AirPods with Wireless Charging Case', model: 'Wireless Charging Case', url: '/custom-product/airpods-with-wireless-charging-case' },
  { name: 'AirPods Pro', model: 'Pro', url: '/custom-product/airpods-pro' },
  { name: 'AirPods Max', model: 'Max', url: '/custom-product/airpods-max' },
];

const countriesImages = {
  US: coverUSImg,
  PE: coverPEImg,
  CO: coverCOImg,
};

const airpods: { [key: string]: AirpodsProduct } = {
  'airpods-with-charging-case': {
    name: 'AirPods with Charging Case',
    model: 'Charging Case',
    title: 'customProduct.airpods.title',
    description: 'customProduct.airpods.description',
    price: '159.00',
    image: withCharger,
    url: 'https://www.apple.com/shop/product/MV7N2AM/A/airpods-with-charging-case',
  },
  'airpods-with-wireless-charging-case': {
    name: 'AirPods with Wireless Charging Case',
    model: 'Wireless Charging Case',
    title: 'customProduct.airpods.title',
    description: 'customProduct.airpods.description',
    price: '199.00',
    image: withWirelessCharger,
    url: 'https://www.apple.com/shop/product/MRXJ2AM/A/airpods-with-wireless-charging-case',
  },
  'airpods-pro': {
    name: 'AirPods Pro',
    model: 'Pro',
    title: 'customProduct.airpods.title',
    description: 'customProduct.airpods.description',
    price: '249.00',
    image: pro,
    url: 'https://www.apple.com/shop/product/MWP22AM/A/airpods-pro',
  },
  'airpods-max': {
    name: 'AirPods Max',
    model: 'Max',
    title: 'customProduct.airpods.title',
    description: 'customProduct.airpods.description',
    price: '549.00',
    images: {
      'space-gray': maxSpaceGray,
      'silver': maxSilver,
      'green': maxGreen,
      'sky-blue': maxSkyBlue,
      'pink': maxPink,
    },
    colors: [
      'space-gray',
      'silver',
      'green',
      'sky-blue',
      'pink',
    ],
    url: 'https://www.apple.com/shop/buy-airpods/airpods-max/',
  },
}

export default class Airpods extends Component<Props, State> {
  airpods: AirpodsProduct;
  pathname: string;
  state = {
    color: '',
    image: '',
    airpods: '',
  };

  constructor(props: Props) {
    super(props);
    const pathname = props.location.pathname.split('/');
    this.pathname = pathname[2];
    this.airpods = airpods[this.pathname];
  }

  componentDidMount() {
    this.setState(() => {
      const st: { [key: string]: string } = {
        airpods: this.airpods.name,
      };
      if (this.airpods.images) {
        st.image = this.airpods.images[Object.keys(this.airpods.images)[0]];
      }else if (this.airpods.image) {
        st.image = this.airpods.image;
      }
      if (this.airpods.colors) st.color = this.airpods.colors[0];
      return st;
    });
  }

  handleChangeAirpods = (airpods: string) => (
    this.setState({ airpods })
  );
  
  handleChangeColor = (color: string) => {
    this.setState(() => {
      const st: { [key: string]: string } = {
        color,
      };
      if (this.airpods.images) st.image = this.airpods.images[color]; 
      return st;
    });
  };
  
  buildUrl = (color: string) => {
    if (this.airpods.model === 'Max') {
      return `${this.airpods.url}${color}`;
    }
    return this.airpods.url;
  };

  buildWeight = () => {
    if (this.airpods.model === 'Max') {
      return '1';
    }
    return '0.3';
  };
  
  render() {
    const { locale } = this.props;
    const { color, image, airpods } = this.state;
    
    const onlineStore = {
      id: 'ST08333814',
      logo: 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Apple.png',
      name: 'Apple',
      slug: 'apple',
      type: 'online - store',
      url: 'https://www.apple.com/',
    };

    const title = this.context.intl.formatMessage({ id: this.airpods.title });
    const description = this.context.intl.formatMessage({ id: this.airpods.description });
    const baseUrl = environment.baseUrl[locale.domainCountry || 'US'];
    const coverImg = countriesImages[locale.domainCountry || 'US'];

    const categoryId = 9;
    
    const price = this.airpods.prices ? this.airpods.prices[color] : this.airpods.price;
    
    return (
      <Fragment>
        <Helmet meta={[
          { name: 'description', content: description },
          { property: 'og:image', content: `${baseUrl}${coverImg}` },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { name: 'twitter:title', content: title },
          { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
          { name: 'twitter:twitter:description', content: description },
        ]}>
          <title>{title}</title>
        </Helmet>
        <ProductBase name={this.airpods.name}
                     image={image}
                     price={price || ''}
                     store={{ image: logoApple, country: 'USA' }}
                     url={this.buildUrl(color)}
                     weight={this.buildWeight()}
                     color={color}
                     onlineStore={onlineStore}
                     categoryId={categoryId}
          /*preferredImportationMethod="lite"*/
        >
          <section className={style.selectModel}>
            <FeatureSelect>
              {airpodsPages.map(
                (o: { [key: string]: string }, i: number) => (
                  <Link key={i}
                        to={o.url}
                        className={classNames({ [featureStyle.active]: o.name === airpods })}
                        onClick={() => this.handleChangeAirpods(o.name)}>
                    <p>Airpods</p>
                    <p className={style.model}>{o.model}</p>
                  </Link>
                )
              )}
            </FeatureSelect>
            
            {this.airpods.colors &&
              <div className={style.selectColor}>
                <FormattedMessage id="customProduct.iphone.color.title">{
                  text => <p>{text}</p>
                }</FormattedMessage>
                <FeatureSelect>
                  {this.airpods.colors.map((c: string, i: number) => (
                    <article key={i} className={classNames({[featureStyle.active]: c === color})}
                             onClick={() => this.handleChangeColor(c)}>
                      <div className={classNames(style.circle, style[c])}/>
                      <p>{c.replace('-', ' ')}</p>
                    </article>))}
                </FeatureSelect>
              </div>
            }
          </section>
        </ProductBase>
      </Fragment>
    );
  }
}

Airpods.propTypes = {
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  location: PropTypes.object,
};

Airpods.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/custom-products/Airpods/components/Airpods.jsx